// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Input$PrezzeeRibbon from "../../../theme/Theme__Input.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var allowedTags = "button";

var regular = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
            BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.px(150)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(50)),
            BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(30)),
            BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(30)),
            BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.zero),
            BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(5))
          ])]);

var small = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(45)),
            BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(22)),
            BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(22)),
            BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.zero),
            BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(3))
          ])]);

var icon = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
            BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.zero),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(38)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(38)),
            BsCssJs$PrezzeeRibbon.boxSizing("contentBox")
          ])]);

var Variant = {
  regular: regular,
  small: small,
  icon: icon
};

var contained = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
            BsCssJs$PrezzeeRibbon.borderStyle("none"),
            BsCssJs$PrezzeeRibbon.borderWidth(BsCssJs$PrezzeeRibbon.zero)
          ])]);

var outlined = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
            BsCssJs$PrezzeeRibbon.borderWidth(BsCssJs$PrezzeeRibbon.px(2)),
            BsCssJs$PrezzeeRibbon.borderStyle("solid")
          ])]);

var none = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
            BsCssJs$PrezzeeRibbon.borderStyle("none"),
            BsCssJs$PrezzeeRibbon.borderWidth(BsCssJs$PrezzeeRibbon.zero)
          ])]);

var Fill = {
  contained: contained,
  outlined: outlined,
  none: none
};

function containedColours(main, secondary, mainHover) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
                    BsCssJs$PrezzeeRibbon.color(secondary),
                    BsCssJs$PrezzeeRibbon.backgroundColor(main),
                    BsCssJs$PrezzeeRibbon.borderColor(main),
                    BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.fast),
                    BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
                    BsCssJs$PrezzeeRibbon.transitionProperty("background-color, border-color"),
                    BsCssJs$PrezzeeRibbon.hover([
                          BsCssJs$PrezzeeRibbon.backgroundColor(mainHover),
                          BsCssJs$PrezzeeRibbon.borderColor(mainHover),
                          BsCssJs$PrezzeeRibbon.disabled([
                                BsCssJs$PrezzeeRibbon.color(secondary),
                                BsCssJs$PrezzeeRibbon.backgroundColor(main)
                              ])
                        ])
                  ])]);
}

function outlinedColours(main, secondary, _mainHover) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
                    BsCssJs$PrezzeeRibbon.color(main),
                    BsCssJs$PrezzeeRibbon.backgroundColor("transparent"),
                    BsCssJs$PrezzeeRibbon.borderColor(main),
                    BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.fast),
                    BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
                    BsCssJs$PrezzeeRibbon.transitionProperty("background-color, color"),
                    BsCssJs$PrezzeeRibbon.hover([
                          BsCssJs$PrezzeeRibbon.color(secondary),
                          BsCssJs$PrezzeeRibbon.backgroundColor(main),
                          BsCssJs$PrezzeeRibbon.disabled([
                                BsCssJs$PrezzeeRibbon.color(main),
                                BsCssJs$PrezzeeRibbon.backgroundColor("transparent")
                              ])
                        ])
                  ])]);
}

function noneColours(main, _secondary, mainHover) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [
                    BsCssJs$PrezzeeRibbon.color(main),
                    BsCssJs$PrezzeeRibbon.backgroundColor("transparent"),
                    BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.fast),
                    BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
                    BsCssJs$PrezzeeRibbon.transitionProperty("background-color, color"),
                    BsCssJs$PrezzeeRibbon.hover([
                          BsCssJs$PrezzeeRibbon.color(mainHover),
                          BsCssJs$PrezzeeRibbon.disabled([BsCssJs$PrezzeeRibbon.color(main)])
                        ])
                  ])]);
}

var Colour = {
  containedColours: containedColours,
  outlinedColours: outlinedColours,
  noneColours: noneColours
};

var normal = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, [BsCssJs$PrezzeeRibbon.boxShadows([
                  Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(4), BsCssJs$PrezzeeRibbon.px(4), BsCssJs$PrezzeeRibbon.px(30), undefined, undefined, BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, BsCssJs$PrezzeeRibbon.pct(24.0))),
                  Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(2), BsCssJs$PrezzeeRibbon.px(2), BsCssJs$PrezzeeRibbon.px(6), undefined, undefined, BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, BsCssJs$PrezzeeRibbon.pct(10.0)))
                ])])]);

var Shadows = {
  none: "",
  normal: normal
};

function universal(borderRadius_) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.selector(allowedTags, [
                    BsCssJs$PrezzeeRibbon.display("inlineFlex"),
                    BsCssJs$PrezzeeRibbon.justifyContent("center"),
                    BsCssJs$PrezzeeRibbon.alignItems("center"),
                    BsCssJs$PrezzeeRibbon.outlineWidth(BsCssJs$PrezzeeRibbon.zero),
                    BsCssJs$PrezzeeRibbon.borderRadius(borderRadius_),
                    BsCssJs$PrezzeeRibbon.cursor("pointer"),
                    BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
                    BsCssJs$PrezzeeRibbon.disabled([
                          BsCssJs$PrezzeeRibbon.opacity(0.5),
                          BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.cursor("notAllowed")])
                        ])
                  ]),
              BsCssJs$PrezzeeRibbon.selector("a", [BsCssJs$PrezzeeRibbon.textDecoration("none")])
            ]);
}

var Universal = {
  universal: universal
};

var partial_arg = Theme__Input$PrezzeeRibbon.InputStyles;

function partial_arg$1(param, param$1) {
  return partial_arg(Variant, Fill, Colour, param, param$1);
}

var Input = partial_arg$1(Shadows, Universal);

var styling = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(allowedTags, Theme__Typography$PrezzeeRibbon.Styles.style5Btn_)]);

var Styles = {
  Input: Input,
  styling: styling
};

function Button(props) {
  var className = props.className;
  var shadow = props.shadow;
  var variant = props.variant;
  var colour = props.colour;
  var fill = props.fill;
  var fill$1 = fill !== undefined ? fill : /* Contained */0;
  var colour$1 = colour !== undefined ? colour : /* Primary */5;
  var variant$1 = variant !== undefined ? variant : /* Regular */0;
  var shadow$1 = shadow !== undefined ? shadow : /* Nothing */0;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  var inputStyling = Curry._5(Input.inputCss, colour$1, fill$1, variant$1, shadow$1, theme);
  var className$2 = BsCssJs$PrezzeeRibbon.merge(Belt_Array.concat(inputStyling, [
            styling,
            className$1
          ]));
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: className$2
            });
}

var make = Button;

export {
  allowedTags ,
  Variant ,
  Fill ,
  Colour ,
  Shadows ,
  Universal ,
  Styles ,
  make ,
}
/* regular Not a pure module */
